import { useTranslation } from 'next-i18next'

import { ExternalLink } from '~/components/ExternalLink'

import { sponsors } from '~/donation/constants/sponsors.const'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const SponsorPage = (): React.ReactElement => {
  const { t } = useTranslation('donation')
  return (
    <section className="flex flex-col items-center mb-11 md:pt-5">
      <h1 className="text-shadow-donation w-64 font-bold text-h3 text-white text-center leading-9 tracking-widest">
        {t('sponsors.label')}
      </h1>
      <div className="gap-5 md:gap-10 grid grid-cols-2 lg:grid-cols-3 mt-12">
        {sponsors.map((sponsor) => (
          <ExternalLink className="" href={sponsor.link} key={sponsor.imageSrc}>
            <div className="inline-flex flex-col justify-center items-center gap-1.5 bg-white px-1.5 py-10 rounded-2.25 lg:rounded-17 w-35 md:w-60 h-28 md:h-48">
              <ResponsiveImage
                alt={sponsor.imageAlt}
                height={sponsor.sizes.desktop.height}
                imageClassName="w-full"
                imageWidths="70, 100, 150, 180, 200, 220"
                loading="eager"
                mediaQuery={sponsor.mediaQuery}
                srcKey={sponsor.imageSrc}
                width={sponsor.sizes.desktop.width}
              />
            </div>
          </ExternalLink>
        ))}
      </div>
    </section>
  )
}

export default SponsorPage
